import { useState } from "react";
import { NJIcon, NJText } from "@engie-group/fluid-design-system-react";
import { MarkdownMessage } from "./MarkdownMessage";

/** Collapsible reasoning block (mirrors the legacy `Reasoning` accordion). */
export function Reasoning({
  content,
  streaming,
}: {
  content: string;
  streaming?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-lg border border-nj-neutral-subtle-default bg-nj-neutral-secondary-default">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        className="flex w-full items-center gap-2 px-3 py-2 text-left"
      >
        <NJIcon name={open ? "expand_less" : "expand_more"} />
        <NJText
          as="span"
          scale="sm"
          className="font-nj-bold text-nj-neutral-secondary-default"
        >
          {streaming ? "Reasoning…" : "Reasoning"}
        </NJText>
      </button>
      {open && (
        <div className="px-3 pb-3 text-sm text-nj-neutral-secondary-default">
          <MarkdownMessage content={content} />
        </div>
      )}
    </div>
  );
}
